import { AdminFinance } from "../../lib/apiTyped";
import { useResource } from "../../lib/useResource";
import { PageHeader } from "../../components/AppLayout";
import { Card } from "../../components/shared/Card";
import { Spinner } from "../../components/shared/Spinner";
import { fmtEur, fmtNumber } from "../../lib/format";

export function AdminOverview() {
  const { data, loading } = useResource(() => AdminFinance.metrics(), []);

  if (loading || !data) {
    return (
      <div className="flex items-center justify-center py-20">
        <Spinner />
      </div>
    );
  }

  const stats: Array<[string, string, string?]> = [
    [
      "MRR",
      fmtEur(data.mrr.eur),
      `${data.mrr.liveSubscriptions} active subscriptions`,
    ],
    ["One-off (30d)", fmtEur(data.oneOffRevenue30dEur), "paid proposals"],
    [
      "Past due",
      fmtNumber(data.pastDueCount),
      "subscriptions with failed payment",
    ],
    [
      "Cancellations (30d)",
      fmtNumber(data.cancellations30d),
      "scheduled or canceled",
    ],
    [
      "Tokens (30d)",
      fmtNumber(data.tokensConsumed30d),
      "sum of usage events",
    ],
  ];

  const seatsByTier = Object.entries(data.mrr.seatsByTier);

  return (
    <>
      <PageHeader
        title="Overview"
        subtitle={`Generated at ${new Date(data.generatedAt).toLocaleString()}`}
      />
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map(([label, value, sub]) => (
          <Card key={label} className="p-5">
            <div className="text-xs font-semibold uppercase tracking-wider text-ink-3">
              {label}
            </div>
            <div className="mt-2 text-2xl font-black text-ink">{value}</div>
            {sub && <div className="text-xs text-ink-3 mt-0.5">{sub}</div>}
          </Card>
        ))}
      </div>

      {seatsByTier.length > 0 && (
        <Card className="p-5 mt-6">
          <div className="text-xs font-semibold uppercase tracking-wider text-ink-3 mb-3">
            Active seats by tier
          </div>
          <ul className="divide-y divide-border">
            {seatsByTier.map(([tier, count]) => (
              <li key={tier} className="py-2 flex justify-between text-sm">
                <span className="text-ink">{tier}</span>
                <span className="text-ink-2">{fmtNumber(count)}</span>
              </li>
            ))}
          </ul>
        </Card>
      )}
    </>
  );
}
